import SubHeader from "./SubHeader";
import SubFooter from "./SubFooter";
import RegistrationBtnGroup from "./RegistrationBtnGroup";
import SectionTitle from "../../components/SectionTitle";
import FAQItem from "../../components/about/FAQItem";

const contentComponentMap = {
  aboutFaqItem: FAQItem,
  registrationBtnGroup: RegistrationBtnGroup,
};

const AboutFaqSection = ({
  id,
  title,
  titleSpan,
  subtitle,
  titleType = "none",
  content = [],
}) => {
  return (
    <>
      <SubHeader />
      <div id={id} className="about-faq-section">
        <div className="container faq-section">
          <SectionTitle
            type={titleType}
            title={title}
            spantitle={titleSpan}
            subtitle={subtitle}
          />
          {(content || []).map((block, i) => {
            const Component = contentComponentMap[block._type];
            if (!Component) {
              console.warn(`Unknown about faq content type: ${block._type}`);
              return null;
            }

            switch (block._type) {
              case 'aboutFaqItem':
                return (
                  <Component
                    key={block._key || i}
                    question={{ en: block.questionEN, jp: block.questionJP }}
                    answer={{ en: block.answerEN, jp: block.answerJP }}
                  />
                );
              case 'registrationBtnGroup':
                return (
                  <Component
                    key={block._key || i}
                    buttons={block.buttons}
                  />
                );
              default:
                return null;
            }
          })}
        </div>
      </div>
      <SubFooter />
    </>
  );
};

export default AboutFaqSection;
